import ReactECharts from 'echarts-for-react';
import { getMetricChartConfigs } from '../charts/metricChartOptions';

const MetricsChartsSection = ({
  charts,
  chartKeyPrefix,
  onChartClick,
  className = '',
  title = 'Аналитика по направлениям',
  subtitle,
}) => {
  const chartConfigs = getMetricChartConfigs(charts);

  return (
    <div className={`charts-section ${className}`.trim()}>
      <div className="charts-section-header">
        <h3>{title}</h3>
        {subtitle && <p className="charts-section-subtitle">{subtitle}</p>}
      </div>
      <div className="charts-grid">
        {chartConfigs.map(({ key, title: chartTitle, options }, index) => (
          <div
            key={key}
            className="chart-container"
            style={{ animationDelay: `${0.1 + index * 0.08}s` }}
            onClick={() => onChartClick(options, chartTitle)}
            title="Нажмите для увеличения"
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onChartClick(options, chartTitle);
              }
            }}
          >
            <div className="chart-container-glow" aria-hidden="true" />
            <ReactECharts
              option={options}
              style={{ height: '400px' }}
              key={`${chartKeyPrefix}-${key}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetricsChartsSection;
